import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    body: {
      plural:
        'For security reasons, it is important that you make your bank cards unusable.',
      singular:
        'For security reasons, it is important that you make your bank card unusable.',
    },
    next: 'I understand',
    title: {
      plural: 'Please cut up your bank cards',
      singular: 'Please cut up your bank card',
    },
  },
  fr: {
    body: {
      plural:
        'Pour des raisons de sécurité, il est important que vous rendiez vos cartes bancaires inutilisables.',
      singular:
        'Pour des raisons de sécurité, il est important que vous rendiez votre carte bancaire inutilisable.',
    },
    next: 'C’est compris',
    title: {
      plural: 'Veuillez découper vos cartes bancaires',
      singular: 'Veuillez découper votre carte bancaire',
    },
  },
});

export default locales;
